<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Wie zijn wij",
    "description": "Bruiloft in je Broekzak is bedacht door twee gezellige nerds."
}'></ngx-json-ld>

<div class="content-box content-box-narrow-content">
  <h1>Wie zijn wij</h1>

  <p>
    Bruiloft in je Broekzak is bedacht door twee gezellige nerds. Als eerste idee is het gemaakt voor een echte bruiloft!
    Dit was zo'n groot succes, dat de app vervolgens de wereld in gebracht is. Op deze manier kan iedereen op een stressvrije
    en betrokken manier een bruiloft organiseren.
    <br />
    <br />
    Rosalyn staat aan het roer van de app. Ze staat altijd klaar om je vragen te beantwoorden.
  </p>
  <a routerLink="/contact" class="button button-primary contact">Neem contact op</a>
</div>

<div class="content-box content-box-responsive left">
  <div class="r-headshot headshot"></div>
  <div class="headshot-text">
    <span class="definition">Rosalyn</span>
  </div>
</div>

<div class="content-box content-box-responsive right">
  <div class="f-headshot headshot"></div>
  <div class="headshot-text">
    <span class="definition">Floor</span>
  </div>
</div>
